export const colors = {
	primary: {
		'400': '#6778ff',
		'50': '#f5f5ff',
	},

	text: {
		'400': '#282934',
		'300': '#717491',
		'50': '#F1F1F4',
	},

	danger: {
		'25': '#fff0f0',
		'50': '#ffe5e5',
		'400': '#ff6767',
	},

	success: {
		'400': '#46cb73',
	},
};
export const theme = {
	color: colors,
};

// OLD TO DELETE

export const themeOld = {
	// Base Colors
	COLOR_BASE_GREEN: '#3DC24B',
	COLOR_BASE_DARK_GREEN: '#224423',
	COLOR_BASE_ORANGE: '#FF9F32',
	COLOR_BASE_YELLOW: '#FFC832',
	COLOR_BASE_RED: '#FF4A4A',

	// Accents
	COLOR_DARK_GREEN_LIGHTEN_76: '#F9FAF9',
	COLOR_DARK_GREEN_LIGHTEN_74: '#F4F6F4',
	COLOR_DARK_GREEN_LIGHTEN_65: '#DBE3DB',
	COLOR_DARK_GREEN_LIGHTEN_46: '#A4B8A5',
	COLOR_DARK_GREEN_LIGHTEN_40: '#8DA58E',
	COLOR_DARK_GREEN_LIGHTEN_23: '#628664',
	COLOR_DARK_GREEN_DARKEN_6: '#282934',

	COLOR_GREEN_LIGHTEN_45: '#E9FBEB',
	COLOR_GREEN_LIGHTEN_42: '#DDF9E0',
	COLOR_GREEN_LIGHTEN_37: '#CCEFD0',
	COLOR_GREEN_LIGHTEN_18: '#93D299',
	COLOR_GREEN_LIGHTEN_2: '#65CD70',
	COLOR_GREEN_DARKEN_6: '#38AD45',

	COLOR_ORANGE_LIGHTEN_38: '#FFFAF5',
	COLOR_ORANGE_LIGHTEN_36: '#FFF5EA',
	COLOR_ORANGE_LIGHTEN_27: '#FFDFBD',
	COLOR_ORANGE_LIGHTEN_17: '#FFC88A',
	COLOR_ORANGE_LIGHTEN_8: '#FFB35C',
	COLOR_ORANGE_DARKEN_10: '#FF8800',

	CELL_HEIGHT: 60,
	CELL_HEIGHT_COMPACT: 44,

	PLAN_HEADER_HEIGHT: 72,
};
